export interface AppOrganizationWizardCreate {
  user_id: string;
  content: {
    name: string;
    address: string;
    city: string;
    country: string;
  };
}

export class AppOrganizationWizardCreate implements AppOrganizationWizardCreate {
  user_id: string;
  content: {
    name: string;
    address: string;
    city: string;
    country: string;
  };

  constructor() {
    this.user_id = "";
    this.content = {
      name: "",
      address: "",
      city: "",
      country: "",
    };
  }
}